// src/dashboard/widgets/ProgressStatsWidget.tsx
//
// Thin wrapper around the legacy ProgressCard. Renders 4 stat tiles
// (Sessions, This-week practice minutes, Avg score, Weekly progress) pulled
// from /api/sessions. Wrapper exists so the legacy component can be placed
// via the config-driven widget registry without modification.

import { ProgressCard } from "@/shared/components/dashboard/ProgressCard";
import { registerWidget } from "@/shared/dashboard/widgets/registry";
import type { WidgetProps } from "@/shared/dashboard/widgets/types";

function ProgressStatsWidgetImpl(_: WidgetProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      <ProgressCard />
    </div>
  );
}

registerWidget({
  id: "progressStats",
  component: ProgressStatsWidgetImpl,
  supportedSlots: new Set(["mainColumn"]),
  displayName: "Progress Stats",
});

export const ProgressStatsWidget = ProgressStatsWidgetImpl;
